import { Injectable } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  Scroll,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private scrollPositions = new Map<string, number>();
  private currentUrl: string = '';
  private isRestoringPosition = false;

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        if (this.currentUrl) {
          const scrollY = window.scrollY || window.pageYOffset;
          this.scrollPositions.set(this.currentUrl, scrollY);
        }
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEnd = event as NavigationEnd;
        const url = navigationEnd.urlAfterRedirects || navigationEnd.url;

        setTimeout(() => {
          const savedPosition = this.scrollPositions.get(url);

          if (savedPosition !== undefined && savedPosition > 0) {
            this.isRestoringPosition = true;

            this.restoreScrollPosition(savedPosition);

            setTimeout(() => {
              this.restoreScrollPosition(savedPosition);
            }, 50);

            setTimeout(() => {
              this.restoreScrollPosition(savedPosition);
              this.isRestoringPosition = false;
            }, 100);
          } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          }

          this.currentUrl = url;
        }, 0);
      });
  }

  private restoreScrollPosition(position: number): void {
    window.scrollTo({
      top: position,
      left: 0,
      behavior: 'instant',
    });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  clearScrollPosition(url: string): void {
    this.scrollPositions.delete(url);
  }

  clearAllScrollPositions(): void {
    this.scrollPositions.clear();
  }
}
